import React from "react";
import PageHeader from "./PageHeader";
import HeaderSection from "./HeaderSection";
import GroupedTripsTable from "./GroupedTripsTable";
import FlaggedTripsTable from "./FlaggedTripsTable";

// The week range comes in via URL from the payments platform (eye-icon
// navigation); there is no in-page date picker — change the week on the
// payments platform and re-click the eye icon.
const DriverDetail = ({ initial_data, logged_in_as, vehicle_svg, week_range }) => {
  const data = initial_data || {};
  const range = week_range || { from: "", to: "" };

  return (
    <main className="min-h-screen bg-gray-100 text-gray-900 font-sans" style={{ whiteSpace: "normal" }}>
      <div className="mx-auto flex flex-col" style={{ maxWidth: 1640, padding: 24, gap: 29 }}>
        <PageHeader loggedInAs={logged_in_as} range={range} />
        <HeaderSection data={data} vehicleSvg={vehicle_svg} />
        <GroupedTripsTable groupedTrips={data.grouped_trips || []} />
        <FlaggedTripsTable flaggedTrips={data.issues || []} />
      </div>
    </main>
  );
};

export default DriverDetail;
